import axios, { AxiosResponse } from 'axios';
import store from '../store';
import router from '../router';

const notificationResponseSuccessInterceptors = function (response: AxiosResponse) {
   return response;
};

const notificationResponseErrorInterceptors = function (error: any) {
   // Ingore everything about squad-filters

   const { response, config: errorConfig } = error || {};
   const { status, config: responseConfig } = response || {};
   const config = responseConfig || errorConfig || {};
   const { url } = config;

   if (config.skipErrorNotification) {
      return Promise.reject(error);
   }

   if (
      (status === 404 && url.includes('candidate-pool')) ||
      (status === 404 && url === 'shift') ||
      (status === 422 && url === 'candidate-pool-squad/per-squad') ||
      (status === 404 && url.includes('squad-filter') && url.includes('layer'))
   ) {
      return;
   }

   if (!axios.isCancel(error)) {
      const ERROR_MESSAGES = [];

      if (error.response?.data?.errors) {
         Object.values(error.response?.data?.errors).forEach((item: any) => {
            ERROR_MESSAGES.push(...item);
         });
      } else if (error.response?.data?.message) {
         ERROR_MESSAGES.push(error.response?.data?.message);
      } else {
         ERROR_MESSAGES.push(error?.message);
      }

      const currentRouteName = router.currentRoute.value?.name as string;
      const isOnPoolImport = currentRouteName?.startsWith('pool-details-import');

      if (
         !(status === 400 && url.includes('import/pool-structure')) &&
         !(status === 422 && url.includes('import/candidates')) &&
         !(status === 400 && url.includes('pool-syntegro')) &&
         !(status === 400 && url.includes('import/candidates/example')) &&
         !(status === 400 && url.includes('import/candidates/validate')) &&
         !(status === 400 && url.includes('export/candidate-pool-tags')) &&
         !(status === 400 && url.includes('import/pool-structure/validate')) &&
         !(status === 400 && url.includes('export/syntegro')) &&
         !(status === 400 && url.includes('import/pool-syntegro/validate')) &&
         !(isOnPoolImport && url.includes('nxt-candidates/lookup/duplicates'))
      ) {
         ERROR_MESSAGES.forEach((error_message) => {
            if (error_message && !error_message.includes('Network error')) {
               store.dispatch(
                  'addNotification',
                  {
                     notification: {
                        type: 'error',
                        message: error_message,
                     },
                  },
                  { root: true },
               );
            }
         });
      }
      return Promise.reject(error);
   } else {
      return Promise.reject('Request aborted');
   }
};

export { notificationResponseErrorInterceptors, notificationResponseSuccessInterceptors };
